import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Form, Button } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { toast } from 'react-toastify';
import { loginApi } from '../services/api.js';
import { createSession, isAuthenticated } from '../services/authenticationService.js';
import '../assets/styles/Login.scss';
import msalInstance from "../services/MicrosoftLoginService.js";

import microLogo from '.././assets/Images/image-5.png';


type FormValues = {
    email: string;
    password: string;
};

// eslint-disable-next-line
const Login = () => {
    const history = useHistory();
    const { register, handleSubmit } = useForm<FormValues>();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if(isAuthenticated())
            redirectToHome();
    }, [])

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        login(data);
    };

    const login = (data) => {
        loginApi(data.email, data.password).then((response) => {
            if (response.token !== undefined && response.token !== null) {
                createSession(response.token, response.username, response.role, data.email);
                redirectToHome();
            } else {
                toast.error(response);
            }
        }).catch((err) => {
            toast.error(err.toString());
        });
    };

    const redirectToHome = () => {
        history.push('/viewer_dashboard');
    };

    const microsoftLogin = (e) => {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem('microsoftLogin', 'true');
        msalInstance.loginRedirect();
    };

    return (
        <>  
            {localStorage.getItem('microsoftLogin') !== 'true' &&
                <>
                    <div className="row mt-5">
                        <div className="col-md col-sm-3 col-2"></div>
                        <div className="form border shadow col-md-3 p-3 col-sm-6 col-8" id="form-sso">
                            <div className="overlap-group">
                                <h3 className="title text-center fs-4 fw-bold"> Login For Walter P Moore </h3>
                                <div className="overlay-group3 position-relative text-center mb-2 p-1">
                                    <button data-testid="microsoft-login" className="btn btn-light ps-3 pe-3 border border-1 vertical-center pointer" onClick={microsoftLogin}>
                                        <img className="image-5" id="image" src={microLogo} alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md col-sm-3 col-2"></div>
                    </div>
                    <div className="row mt-3">
                            <div className="col-md col-sm-3 col-2"></div>
                            <Form className="form border shadow col-md-3 p-3 col-sm-6 col-8 p-3" data-testid="login-form" id="form-normal" onSubmit={handleSubmit(onSubmit)}>
                                <div id="heading" className="title text-center fs-4 fw-bold">Login For Katy ISD</div>
                                <Form.Group className="mb-3 mx-4">
                                    <Form.Label> Email </Form.Label>
                                    <Form.Control
                                        type="email" name="username" placeholder="Enter Email" data-testid="email" {...register("email")}
                                        onInvalid={(e) => (e.target as HTMLInputElement).setCustomValidity("Please enter your e-mail address")}
                                        onInput={(e) => (e.target as HTMLInputElement).setCustomValidity("")} required />
                                </Form.Group>
                                <Form.Group className="mb-3 mx-4">
                                    <Form.Label> Password </Form.Label>
                                    <div style={{ position: 'relative' }}>
                                        <Form.Control type={showPassword ? 'text' : 'password'} name="password" data-testid="password" placeholder="Enter Password" {...register("password")}
                                            onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Please enter your password')}
                                            onInput={e => (e.target as HTMLInputElement).setCustomValidity('')} required style={{ width: '100%', paddingRight: '40px' }} />
                                        <span
                                            style={{
                                                position: 'absolute',
                                                right: '10px', // Adjust the position of the icon as needed
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ?
                                                <Icon.Eye className='m-2 pointer' onClick={() => setShowPassword(false)} />
                                                :
                                                <Icon.EyeSlash className='m-2 pointer' onClick={() => setShowPassword(true)} />}
                                        </span>
                                    </div>
                                </Form.Group>
                                <div className="text-end mt-3">
                                    <Link to="/forgot_password" data-testid="forgotpwd" id="forgotpwd" className="forgotpwd pointer text-center mx-4 "> Forgot Password? </Link>
                                </div>
                                <div className="text-center">
                                    <Button id="submit" className="btn btn-primary mt-1 text-center mx-auto d-block" data-testid="submit-button" type="submit"> Login </Button>
                                </div>
                            </Form>
                            <div className="col-md col-sm-3 col-2"></div>
                    </div>
                </>
            }
        </>
    );
}
export default Login;